//
import apiHandler from './base/createApiHandler';

export default apiHandler;
